// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchBar-cls1_704","cls2":"SearchBar-cls2_Vcu SearchBar-cls1_704","redesign":"SearchBar-redesign_VsV"};